<template>
    <div v-if="uiStore.isMobile || uiStore.isTablet" :class="injectSideMenuMobile ? 'd-none' : null">

        <div id="app-mobile-start-menu-container" class="accordion-side-menu" v-if="injectSideMenuMobile">
            <slot/>
        </div>
        <nav v-else class="start-menu-mobile mt-2 mb-5 pt-3" ref="nav">
            <slot/>
        </nav>
    </div>
    <aside v-else class="accordion-side-menu side-menu side-menu-start" :class="cssClass"  :style="`height: ${uiStore.viewHeightStyle}`">
        <badge color="light" class="border toggle-menu" :action="toggleMenu" v-if="enableCollapse" :style="collapseTopMargin">
            <i class="fas" :class="showMenu ? 'fa-angle-double-left' : 'fa-angle-double-right'"></i>
        </badge>
        <nav class="menu-container" ref="nav" :style="startNavTopPadding">
            <slot/>
        </nav>
    </aside>
</template>

<script type="text/javascript">
    import { UseUIStore } from '@/store/UI.js';
    import Badge from '@/components/UI/Badge.vue';
    import UI from '@/classes/UI.js';

    export default {

        components: {
            Badge
        },

        setup() {
            return {
                uiStore: UseUIStore(),
            };
        },

        data() {
            return {
                showMenu: true,
                transitioning: false,
                mountedDelay: false,
                injectSideMenuMobile: UI.injectSideMenuInMobile(),
            };
        },

        props: {
            flat: {
                type: Boolean,
                default: false,
            },
        },

        watch: {
            $route() {
                if ((!this.uiStore.isMobile) && (!this.uiStore.isTablet)) {
                    // we'll wait for page transitions to finish
                    setTimeout(this.scrollToActive, 500);
                }
            }
        },

        created() {
            this.showMenu = ! this.collapse;
        },

        mounted() {
            requestAnimationFrame(function() {
                this.mountedDelay = true;
                this.scrollToActive();
            }.bind(this));
        },

        computed: {
            
            cssClass() {
                let cssClss = [];
                if (!this.flat) {
                    cssClss.push('bg-light');
                    cssClss.push('border-end');
                    cssClss.push('border-top');
                }
                if (!this.showMenu) {
                    cssClss.push('hide');
                }
                if (this.transitioning) {
                    cssClss.push('transitioning');
                }

                if ((this.uiStore.floatingMenu) && (this.uiStore.visibleHeader)) {
                    cssClss.push('floating-menu-top');
                }
                return cssClss;
            },

            collapse() {
                if (this.$route.meta.collapseStartMenu != null) {
                    return this.$route.meta.collapseStartMenu;
                }
                return false;
            },

            enableCollapse() {
                
                if (this.flat) {
                    return !this.showMenu;
                }
                if (this.$route.meta.enableStartMenuCollapse != null) {
                    return this.$route.meta.enableStartMenuCollapse;
                }
                return true;
            },

            startNavTopPadding() {
                if (this.uiStore.stickTopNavTop) {
                    return `padding-top: ${this.uiStore.stickTopNavTop}px`;
                }
                else if (this.uiStore.floatingMenu) {
                    return `padding-top: ${this.uiStore.visibleHeader}px`;
                }
                return null;
            },

            collapseTopMargin() {
                if (this.uiStore.stickTopNavTop) {
                    return `margin-top: ${this.uiStore.stickTopNavTop}px`;
                }
                else if (this.uiStore.floatingMenu) {
                    return `margin-top: ${this.uiStore.visibleHeader}px`;
                }
                return null;
            },
        },

        methods: {
            toggleMenu() {
                this.transitioning = true;
                setTimeout(function() {
                    this.transitioning = false;
                }, 500);
                this.showMenu = ! this.showMenu;
            },

            scrollToActive() {
                if (!this.$refs.nav) return;

                // mobile
                if (this.uiStore.isMobile || this.uiStore.isTablet) {
                    if (!this.injectSideMenuMobile) {
                        let elm = this.$refs.nav.querySelector('.active');

                        if (elm) {
                            UI.hScrollToChild(this.$refs.nav, elm, false, 'center');
                        }
                    }
                }
                // desktop
                else {
                    let elm = this.$refs.nav.querySelector('[data-active]');
                    if (elm) {
                        elm.scrollIntoView({
                            block: 'nearest',
                            inline: 'start',
                            behavior: 'smooth',
                        });
                    }
                }
            },
        },

        
    };

</script>
